import type { useTranslation } from 'react-i18next';

type TFunction = ReturnType<typeof useTranslation>['t'];

/** The fields a Connect control reads from a connection state. */
export interface ConnectButtonState {
  status?: string | null;
  requestedByViewer: boolean;
}

/** Someone asked the viewer to connect: the control should lead to the requests page. */
export function isIncomingRequest(state?: ConnectButtonState | null) {
  return state?.status === 'PENDING' && !state.requestedByViewer;
}

/** Connect-button label for a `social` namespace `t`. */
export function getConnectButtonLabel(t: TFunction, state?: ConnectButtonState | null) {
  if (state?.status === 'ACCEPTED') return t('connection.connected');
  if (state?.status === 'PENDING') {
    return state.requestedByViewer ? t('connection.request-sent') : t('connection.respond-to-request');
  }
  if (state?.status === 'BLOCKED') return t('connection.unavailable');
  return t('connection.connect');
}

export function getConnectButtonShortLabel(t: TFunction, state?: ConnectButtonState | null) {
  if (isIncomingRequest(state)) {
    return t('connection.respond-to-request-short');
  }
  return getConnectButtonLabel(t, state);
}

export function isConnectButtonDisabled(state?: ConnectButtonState | null) {
  return state?.status === 'ACCEPTED' || state?.status === 'PENDING' || state?.status === 'BLOCKED';
}
